<template>
<Header hrefTo="#mainView"/>
<Main heading="Contact Us">
  <main-view :isContactPage="true">
    <div class="title">
        <h2> Contact Details</h2> 
<!--         <div class="alert">
          <span class="orange">
            <span class="icon download"></span>
            <p>ICRT is moving offices. From <strong>7th June 2022</strong>, our new address will be  <strong>Oxford House, 49a Oxford Road, London. N4 3EY</strong>. Please update your records and continue to send all correspondence electronically.</p>
          </span>
         </div> -->
    </div>

    <div class="contact-information__wrapper">
      <div class="office"  v-for="office in offices" :key="office.id">
              <div class="address">
               <h3>{{office.title}}</h3>
                  <address class="address">
                    <div><span class="icon location"></span> <p>{{office.building}}<span>{{office.street}}</span><span>{{office.city}} {{office.postCode === '' ? '' : `, ${office.postCode}`}}</span><span>{{office.country}}</span></p></div>
                    <div><span class="icon phone"></span> <a :href="`tel:${office.phoneNumber}`"><p>Call us on {{office.phoneNumber}}</p></a></div>
                     <div v-if="office.country === 'United Kingdom'"><a href="/docs/map.pdf" download="icrt-route-map"><span class="icon download"></span><p>Download Route Map (.pdf)</p></a></div>
                    <div v-else class="simulate_button"></div>
                  </address>
              </div>
              <iframe v-if="office.country === 'Germany'" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.879402916848!2d6.862431315828271!3d51.294943334035764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8c9d0ced6f303%3A0x75aecbdf9a5688cc!2sRegus%20-%20Ratingen%2C%20Ost!5e0!3m2!1sen!2suk!4v1657705002565!5m2!1sen!2suk" style="border:0; width: 100%; height: 500px" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              <iframe v-else src="https://maps.google.com/maps?q=Oxford%20House,%2049a%20Oxford%20Road,%20London.%20N4%203EY&t=&z=13&ie=UTF8&iwloc=&output=embed" style="border:0; width: 100%; height: 500px" allowfullscreen="" loading="lazy"></iframe>
      </div>
    </div>


    <div class="information">
      <h3>Membership Queries</h3>
      <p>If you are interested in becoming a member, please call our London office or contact us in writing. All membership enquiries should be addressed to the Company Secretary of ICRT, Oxford House, 49a Oxford Road, London, N4 3EY, United Kingdom or send to helpdesk@international-testing.org.</p>
      <h3>General Queries</h3>
      <p> <span class="icon email"></span>Send email to helpdesk@international-testing.org</p>
    </div>
  </main-view>
</Main>
<Footer />
</template>

<script>
import { useGtag } from "vue-gtag-next";
import Header from "../../components/Header/_Header.vue";
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue"
import Footer from "../../components/Footer/_Footer";

export default {
  name: "Contact",
  data() {
    return {
      offices: [
       {  id: 1,
          title: "ICRT LTD London Office",
          building: 'Oxford House',
          street: "49a Oxford Road",
          city: "London",
          postCode: "N4 3EY",
          phoneNumber: "+44 (0) 207 563 9170",
          country: 'United Kingdom',
        },
        {
          id: 2,
          title: "ICRT GmbH Germany Office",
          building: 'c/o Regus',
          street: "Kokkolastrasse 5-7",
          city: "40882 Ratingen",
          postCode: "",
          phoneNumber: "+49 (0) 2102 564 6039",
          country: 'Germany',
        }
        ],
    };
  },
  components: {
    Header,
    Main,
    MainView,
    Footer,
  },
};
</script>

<style lang="scss">
  @import "./contact.scss";
</style>
